<!-- eslint-disable i18next/no-literal-string -->
<template>
  <div>
    <div class="d-flex">
      <div class="mx-1">
        <b-button variant="primary" @click="modal = true">Modal Basic</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal2 = true">Modal Icon</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal3 = true">Modal Without Header</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal4 = true">Modal With Divider</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal5 = true">Modal Divider & Field</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal6 = true">Modal Title & Field</b-button>
      </div>
      <div class="mx-1">
        <b-button variant="primary" @click="modal7 = true">Modal List</b-button>
      </div>
    </div>
    <McConfirmation 
      :value.sync="modal" 
      message="Are you sure to continue?" 
      title="Title" 
    />
    <McConfirmation 
      :value.sync="modal2" 
      message="Are you sure to continue?" 
      size="sm" 
      body-icon="success"
      body-title="Title"
      body-class="text-center"
      footer-class="justify-content-center"
      hide-header
      ok-only
      ok-title="Ok"
    />
    <McConfirmation 
      :value.sync="modal3" 
      message="Are you sure to continue?" 
      body-title="Main question 3?"
      body-title-variant="primary"
      hide-header
    />
    <McConfirmation 
      :value.sync="modal4" 
      message="Are you sure to continue?" 
      body-title="Main question 4?"
      body-title-divider
      hide-header
    />
    <mc-confirmation 
      :value.sync="modal5" 
      message="Status DO-001 akan berbuah dari Dikonfirmasi -> Dibatalkan" 
      body-title="Batalkan Pengiriman?"
      body-title-divider
      hide-header
      ok-title="Hapus"
      @handle-ok="handleOk()"
    >
      <div class="form-group">
        <label for="exampleInputEmail1">Alasan Pembatalan</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
        <small id="emailHelp" class="form-text text-muted"><span class="text-danger">*</span> <span class="fst-italic">Mandatory</span></small>
      </div>
    </mc-confirmation>
    <mc-confirmation 
      :value.sync="modal6" 
      title="Batal"
      message="Status DO-001 akan berbuah dari Dikonfirmasi -> Dibatalkan" 
      body-title="Batalkan Pengiriman?"
      ok-title="Hapus"
      @handle-ok="handleOk()"
    >
      <div class="form-group">
        <label for="exampleInputEmail1">Alasan Pembatalan</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
        <small id="emailHelp" class="form-text text-muted"><span class="text-danger">*</span> <span class="fst-italic">Mandatory</span></small>
      </div>
    </mc-confirmation>
    <mc-confirmation 
      :value.sync="modal7" 
      title="Batal"
      message="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor." 
      hide-header
      size="sm"
    >
      <b-list-group>
        <b-list-group-item v-for="n in 5" :key="n">Label</b-list-group-item>
      </b-list-group>
    </mc-confirmation>
  </div>
</template>
<script>
import McConfirmation from "./index.vue";
export default {
  components: { McConfirmation },
  data() {
    return {  
      modal: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      modal6: false,
      modal7: false
    }
  },
  methods: {
    handleOk() {
      console.log('OKE')
    }
  }
}
</script>